export interface Breakpoints {
  /**
   * (min-width: 640px)
   */
  sm: string;
  /**
   * (min-width: 768px)
   */
  md: string;
  /**
   * (min-width: 1024px)
   */
  lg: string;
  /**
   * (min-width: 1280px)
   */
  xl: string;
  /**
   * (min-width: 1536px)
   */
  xxl: string;
}

export const smValue = 640;
export const mdValue = 768;
export const lgValue = 1024;
export const xlValue = 1280;
export const xxlValue = 1536;

export const sm = `(min-width: ${smValue}px)`;
export const md = `(min-width: ${mdValue}px)`;
export const lg = `(min-width: ${lgValue}px)`;
export const xl = `(min-width: ${xlValue}px)`;
export const xxl = `(min-width: ${xxlValue}px)`;
